<!-- ========================== footer (start) ========================== -->	
<footer class="l-footer">
            
        <ul class="footer-menu">
            <li class="footer-menu-item">
                <a class="footer-menu-link">
                    Support Center
                </a>
            </li>
            <li class="footer-menu-item"><a class="footer-menu-link" routerLink="/privacy-policy"> Privacy Policy </a></li>
            <li class="footer-menu-item">
                <a class="footer-menu-link">
                    Terms of Use
                </a>
            </li>
        </ul>
        
        <div class="footer-credit">
            © 2006-{{ currentYear }} Artisan Sonics, Inc
        </div>

    </footer>
    <!-- ========================== footer (end) ========================== -->	
